export const setProfileMapData = (state, action) => {
  state.countDetails = action.payload;
};

export const setTradeLaneCategory = (state, action) => {
  state.portCategory = action.payload;
};

export const setTabDetails = (state, action) => {
  state.tabDetails = action.payload;
};

export const setProfileRedirectionId = (state, action) => {
  state.profileRedirectionId = action.payload;
};

export const setTradeLaneCachingHandler = (state, action) => {
  state.tradeLaneCaching = action.payload;
};
